import { ref } from '@vue/runtime-dom'
import { enumToOption } from '@/utils'

// 状态
export enum isAble {
  启用 = 0,
  禁用
}

// 报警等级枚举
enum AlarmLevel {
  一级 = 0,
  二级,
  三级
}

// 报警分类枚举
enum AlarmClassify {
  违规 = 1,
  报警,
  提醒,
  风控,
  故障
}

// 报警等级选项
const alarmLevelOptions = enumToOption(AlarmLevel)

// 报警分类选项
const alarmClassifyOptions = enumToOption(AlarmClassify)

export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度
    height: null,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // table 索引 label
    indexLabel: '序号',
    // table 工具设置选项 配置则默认开启
    // tool: {
    //   // 列表本地储存name
    //   columnStorageName: 'driver-depot'
    // },
    tool: null,
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: false,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'alarmTypeName',
      label: '报警名称',
      width: '200'
    },
    {
      key: 'alarmClassify',
      label: '报警类型',
      width: '140',
      slot: 'alarmClassify'
    },
    {
      key: 'alarmLevel',
      label: '报警等级',
      width: '140',
      slot: 'alarmLevel'
    },
    {
      key: 'systemClassify',
      label: '系统分类',
      width: '140',
      slot: 'systemClassify'
    },
    {
      key: 'action',
      label: '操作',
      width: '200',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置


export const inputList = () => [
  {
    type: 'select',
    label: '报警等级',
    key: 'alarmLevel',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: alarmLevelOptions,
    rules: {
      type: 'number'
    }
  },
  {
    type: 'select',
    label: '报警类型',
    key: 'alarmClassify',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: alarmClassifyOptions,
    rules: {
      type: 'number'
    }
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}